/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumera los campos que pueden editarse de un evento.
 */
export type ActividadPatchFieldsEnum = 'publish' | 'titulo' | 'info' | 'itinerario' | 'incluye' | 'noIncluye' | 'recomendaciones' | 'terminoCondiciones' | 'devoluciones' | 'formatText' | 'fecha' | 'finalizacion' | 'valor' | 'categoria' | 'clasificacion' | 'programacionLunes' | 'programacionMartes' | 'programacionMiercoles' | 'programacionJueves' | 'programacionViernes' | 'programacionSabado' | 'programacionDomingo';

export const ActividadPatchFieldsEnum = {
    Publish: 'publish' as ActividadPatchFieldsEnum,
    Titulo: 'titulo' as ActividadPatchFieldsEnum,
    Info: 'info' as ActividadPatchFieldsEnum,
    Itinerario: 'itinerario' as ActividadPatchFieldsEnum,
    Incluye: 'incluye' as ActividadPatchFieldsEnum,
    NoIncluye: 'noIncluye' as ActividadPatchFieldsEnum,
    Recomendaciones: 'recomendaciones' as ActividadPatchFieldsEnum,
    TerminoCondiciones: 'terminoCondiciones' as ActividadPatchFieldsEnum,
    Devoluciones: 'devoluciones' as ActividadPatchFieldsEnum,
    FormatText: 'formatText' as ActividadPatchFieldsEnum,
    Fecha: 'fecha' as ActividadPatchFieldsEnum,
    Finalizacion: 'finalizacion' as ActividadPatchFieldsEnum,
    Valor: 'valor' as ActividadPatchFieldsEnum,
    Categoria: 'categoria' as ActividadPatchFieldsEnum,
    Clasificacion: 'clasificacion' as ActividadPatchFieldsEnum,
    ProgramacionLunes: 'programacionLunes' as ActividadPatchFieldsEnum,
    ProgramacionMartes: 'programacionMartes' as ActividadPatchFieldsEnum,
    ProgramacionMiercoles: 'programacionMiercoles' as ActividadPatchFieldsEnum,
    ProgramacionJueves: 'programacionJueves' as ActividadPatchFieldsEnum,
    ProgramacionViernes: 'programacionViernes' as ActividadPatchFieldsEnum,
    ProgramacionSabado: 'programacionSabado' as ActividadPatchFieldsEnum,
    ProgramacionDomingo: 'programacionDomingo' as ActividadPatchFieldsEnum
};

